import './Topbar.scss'
import type { ReactNode, Ref } from 'react'
import { MdOutlineRefresh } from 'react-icons/md'
import { Link } from 'react-router-dom'
import { IconButton } from '../../ui'
import { UserMenu } from '../UserMenu'

export interface TopbarProps {
  onRefresh: () => void
  onLogout: () => void
  user?: { name: string } | null | undefined
  /** The EnvBanner (or nothing). */
  envBanner?: ReactNode
  /** The drawer's menu button, below `tablet`. */
  menuButton?: ReactNode
  ref?: Ref<HTMLElement>
}

const logoSrc = `${import.meta.env.APP_BASE_PATH || '/'}images/oap-logo-transparent.png`

/** The banner landmark: logo, env banner, Refresh and the user menu (CustomAppBar.tsx). */
export function Topbar({ onRefresh, onLogout, user, envBanner, menuButton, ref }: TopbarProps) {
  return (
    <header ref={ref} className="topbar">
      {menuButton}
      <Link to="/" className="topbar__logo">
        <img
          src={logoSrc}
          alt="Oase Admin Portal"
          width={72}
          height={32}
          className="topbar__logo-image"
        />
      </Link>
      <div className="topbar__banner">{envBanner}</div>
      <div className="topbar__actions">
        <IconButton label="Refresh" icon={<MdOutlineRefresh />} onClick={onRefresh} />
        <UserMenu name={user?.name} onLogout={onLogout} />
      </div>
    </header>
  )
}
